import { FeatureDefinition } from '../entities';

export const precheckoutModalExperiment = 'precheckout_modal';

export enum PrecheckoutModalExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const precheckoutModalExperimentConfig: FeatureDefinition = {
  defaultValue: PrecheckoutModalExperimentGroups.CONTROL,
};
